export class Transaction {
    transactionId: string;
    transactionStatusId: number;
    brandId: string;
    idNumber: string;
    vin: string;
    odometerReadingKm: number;
    newPlanType: string;
    newPlanYears: number;
    newPlanDistanceKm: number;
    newPlanTotalExcludingVat: number;
    newPlanTotalIncludingVat: number;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    emailAddress: string;
    sapContractNumber: string;
    isHappyToBeContacted: boolean;
    isAcceptedTermsAndConditions: boolean;
    dateTimeCreated: Date;
    dateTimeLastPaymentAttempt: Date;
    dateTimePaymentSuccessful: Date;
    dateTimeSAPPosted: Date;
    payUReference: string;
    errorMessage: string;
    salesDocType: string;
    isOwnerDetailsUpdated: boolean;
    isCustomPlan: boolean;

    brandCode: string;
    brandName: string;
    planDescription: string;
    modelCode: string;
    modelName: string;
    modelDescription: string;
    engineNumber: string;
    deliveryDate: string;
    currentPlanType: string;
    currentPlanStartDate: string;
    currentPlanEndDate: string;
    currentPlanStartKms: number;
    currentPlanEndKms: number;
    newPlanStartDate: Date;
    newPlanEndDate: Date;
    newPlanStartKms: number;
    newPlanEndKms: number;
    warrantyStatus: string;
    warrantyStartDate: Date;
    warrantyEndDate: Date;
    warrantyEndKM: number;
    isAbandonedEmailSentUser: boolean;
    returnUrl: string;
}
